<template>
  <div class="tw:print:hidden">
    <div class="tw:flex tw:shadow-xs tw:rounded-md">
      <div class="tw:-mr-px tw:flex-1 tw:grid tw:grid-cols-1 tw:focus-within:relative">
        <input
          type="search"
          v-model="search"
          :class="[
            'tw:col-start-1 tw:row-start-1 tw:pl-10 tw:w-full tw:rounded-md tw:outline-1 tw:-outline-offset-1 tw:outline-zinc-300 tw:focus:outline-2 tw:focus:-outline-offset-2 tw:focus:outline-blue-600 tw:px-4 tw:py-2',
            slot['input-group-append'] ? 'tw:rounded-r-none' : 'tw:rounded-r-md',
          ]"
          :placeholder="placeholder"
          ref="searchInput"
          autocorrect="off"
          spellcheck="false"
          :autofocus="props.autofocus"
        >
        <div class="tw:pointer-events-none tw:col-start-1 tw:row-start-1 tw:self-center tw:ml-3">
          <Search class="tw:size-5 tw:text-zinc-500" />
        </div>
      </div>

      <slot name="input-group-append"></slot>
    </div>
  </div>
</template>

<script setup>
import { Search } from '@lucide/vue';
import { useDebounceFn } from '@vueuse/core'
import { useTemplateRef, ref, watch, onMounted, useSlots } from "vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: ""
  },
  autofocus: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: "Search..."
  }
})

const slot = useSlots()

const search = ref(props.modelValue)

watch(
  () => props.modelValue,
  (newVal) => {
    search.value = newVal;
  }
)

const emit = defineEmits(['update:modelValue'])
const debouncedUpadeModelValue = useDebounceFn(async () => {
  emit("update:modelValue", search.value);
}, 500);

watch(
  () => search.value,
  (newVal) => {
    if (newVal !== props.modelValue) {
      debouncedUpadeModelValue();
    }
  },
)

const searchInputRef = useTemplateRef('searchInput')
onMounted(() => {
  if (props.autofocus) {
    searchInputRef.value.focus();
  }
})
</script>
